export const CREATE_DOC = "CREATE_DOC";
export const CREATE_DOC_SUCCESS = "CREATE_DOC_SUCCESS";
export const CREATE_DOC_FAILED = "CREATE_DOC_FAILED";
export const CREATE_DOC_RESET = "CREATE_DOC_RESET";
export const UPLOAD_DOC = "UPLOAD_DOC";
export const UPLOAD_DOC_SUCCESS = "UPLOAD_DOC_SUCCESS";
export const UPLOAD_DOC_FAILED = "UPLOAD_DOC_FAILED";
